import React, { useState, useEffect } from 'react';
import {
  TableRow,
  TableCell,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl
} from '@mui/material';

export type PropertyType = 'Simple' | 'Schema' | 'Enum';

interface AddPropertyTypeSelectorProps {
  onTypeSelected: (type: PropertyType) => void;
}

const AddPropertyTypeSelector: React.FC<AddPropertyTypeSelectorProps> = ({ onTypeSelected }) => {
  const [selectedType, setSelectedType] = useState<PropertyType>('Simple');

  useEffect(() => {
    onTypeSelected(selectedType); // Emit default on mount
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newType = event.target.value as PropertyType;
    setSelectedType(newType);
    onTypeSelected(newType);
  };

  return (
    <TableRow>
      <TableCell colSpan={6}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            name="property-type"
            value={selectedType}
            onChange={handleChange}
          >
            <FormControlLabel value="Simple" control={<Radio />} label="Simple" />
            <FormControlLabel value="Schema" control={<Radio />} label="Schema" />
            <FormControlLabel value="Enum" control={<Radio />} label="Enum" />
          </RadioGroup>
        </FormControl>
      </TableCell>
    </TableRow>
  );
};

export default AddPropertyTypeSelector;
